import { createContext, useContext } from 'react';

import { ItemLayoutType, TimeKeepingRecords, TimeKeepingSession } from '../types';

export type TimeKeepingContextValue = {
  // Layout
  items: ItemLayoutType[];
  sessionSupports: string[];
  selectedLogos: string[];
  selectedPeople: string[];
  // Sessions
  sessions: TimeKeepingSession[];
  activeSessionId: string | undefined;
  // Item actions
  onRemoveItem: (compositeId: string) => void;
  onColsChange: (cols: number) => void;
  onItemSupportsChange: (compositeId: string, selectedIds: string[]) => void;
  // Record actions
  onAddRecord: (compositeId: string, supportPresenceId: string, record: TimeKeepingRecords) => void;
  onUpdateRecord: (
    compositeId: string,
    supportPresenceId: string,
    recordIndex: number,
    partial: Partial<TimeKeepingRecords>
  ) => void;
  onRemoveRecord: (compositeId: string, supportPresenceId: string, recordIndex: number) => void;
  onResetRecords: (compositeId: string, supportPresenceId?: string) => void;
  buildNewRecord: () => TimeKeepingRecords;
  // Filter actions
  onLogosChange: (logos: string[]) => void;
  onPeopleChange: (people: string[]) => void;
  onSupportsChange: (supports: string[]) => void;
  // Session actions
  onSaveSession: (name: string) => void;
  onLoadSession: (session: TimeKeepingSession) => void;
  onClearSession: () => void;
  onDeleteSession: (sessionId: string) => void;
  onAutoSort: () => void;
};

export const TimeKeepingContext = createContext<TimeKeepingContextValue | null>(null);

export function useTimeKeepingContext(): TimeKeepingContextValue {
  const ctx = useContext(TimeKeepingContext);
  if (!ctx)
    throw new Error('useTimeKeepingContext must be used inside TimeKeepingContext.Provider');
  return ctx;
}
